<template>
    <pending-products :model="model" :schema="schema" :headers="headers" :details_headers="details_headers"></pending-products>
</template>

<script>
import MainLayout from './../../Layouts/MainLayout';

export default {
    layout: MainLayout,

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        details_headers: [Object, Array],
    },
};
</script>
